import PropTypes from 'prop-types';
import { Icon } from '@iconify/react';
import { paramCase } from 'change-case';
import { useRef, useState } from 'react';
import editFill from '@iconify/icons-eva/edit-fill';
import downloadFill from '@iconify/icons-eva/download-fill';
import { Link as RouterLink } from 'react-router-dom';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText, Box, Button } from '@material-ui/core';
// routes
// eslint-disable-next-line import/no-unresolved
import { PATH_DASHBOARD } from 'src/routes/paths';
import { Restore } from '@material-ui/icons';

// ----------------------------------------------------------------------

TableMoreMenu.propTypes = {
  onDelete: PropTypes.func,
  onDisable: PropTypes.func,
  onRestore: PropTypes.func,
  onEdit: PropTypes.func,
  onDownload: PropTypes.func,
  data: PropTypes.object,
  status: PropTypes.bool
};

export default function TableMoreMenu({
  onDelete,
  onEdit,
  onDisable,
  onRestore,
  onDownload = () => {},
  data = {},
  status = true
}) {
  const ref = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <IconButton ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {status ? (
          <Box>
            <MenuItem onClick={() => onEdit(data?.id)} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={editFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
            <MenuItem onClick={(e) => onDownload(e, data?.master_file)} to="#" sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={downloadFill} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Download" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
          </Box>
        ) : (
          <Box>
            <MenuItem onClick={onDelete} sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Icon icon={trash2Outline} width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
            <MenuItem onClick={onRestore} to="#" sx={{ color: 'text.secondary' }}>
              <ListItemIcon>
                <Restore width={24} height={24} />
              </ListItemIcon>
              <ListItemText primary="Restore" primaryTypographyProps={{ variant: 'body2' }} />
            </MenuItem>
          </Box>
        )}
      </Menu>
    </>
  );
}
